import {get, orderBy} from 'lodash-es';
import {ChannelCatalogItemWithState} from 'views/programming/channel/contexts/getMemoryListProvider';

const getSplittedSort = (sort: string) => {
  const splitedSort = sort.split(':');
  return splitedSort;
};

export const sortList = (queue: ChannelCatalogItemWithState[], sort: string): ChannelCatalogItemWithState[] => {
  const tempQueue = [...queue];
  const [sortKey, sortOrder] = getSplittedSort(sort);

  const comparator = (key: string) => (a: ChannelCatalogItemWithState, b: ChannelCatalogItemWithState) => {
    const aValue = get(a, key);
    const bValue = get(b, key);

    if (aValue > bValue) {
      return sortOrder === 'asc' ? 1 : -1;
    }
    if (aValue < bValue) {
      return sortOrder === 'asc' ? -1 : 1;
    }
    return 0;
  };

  return tempQueue.sort(comparator(sortKey));
};

export const sortQueue = (queue: ChannelCatalogItemWithState[], sort: string): ChannelCatalogItemWithState[] => {
  const tempQueue = [...queue];

  // eslint-disable-next-line prefer-const
  const [sortKey, sortOrder] = getSplittedSort(sort);

  let allSortOrder: 'asc' | 'desc' = 'asc';

  // For lodash's benefit
  if (sortOrder === 'dsc') {
    allSortOrder = 'desc';
  }

  let sortKeys: (string | ((a: ChannelCatalogItemWithState) => string))[] = [];
  let sortOrders: ('asc' | 'desc')[] = [];

  if (sortKey === 'author') {
    sortKeys = ['author', a => a.series.name, 'season', 'number'];
    sortOrders = [allSortOrder, allSortOrder, allSortOrder, allSortOrder];
  } else {
    sortKeys = [sortKey];
    sortOrders = [allSortOrder];
  }

  return orderBy(tempQueue, sortKeys, sortOrders);
};
